import { useParams } from "react-router-dom";
import { useQuery } from "convex/react";
//import { api } from "../../convex/_generated/api";
import {api} from "./convex/_generated/api"

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";
//import Loader from "../components/Loader";


export default function WasteDashboard() {


  const { userId } = useParams();

  const dashboard = useQuery(
  api.wasteSavings.getWasteDashboard,
  userId
    ? { userId }
    : "skip"
);

//console.log(dashboard);

  const weeklySavings = useQuery(
  api.wasteSavings.getWeeklySavings,
  userId
    ? { userId }
    : "skip"
);

 //console.log("weeb");
 //console.log(weeklySavings);



  //if(!dashboard){
    //return <Loader />;
  //}



  return (

    <div className="screen">


      <div className="eyebrow">
        Waste Savings
      </div>


      <h1 className="page-title">
        Zero Waste Dashboard
      </h1>



      <div
        className="ticket"
        style={{
          background: "var(--accent-dim)",
          borderColor: "var(--accent)",
        }}
      >
        <p
          style={{
            margin: 0,
            fontFamily: "var(--font-mono)",
            fontSize: 13,
            color: "var(--accent)",
          }}
        >
          🔥 {dashboard?.streak}{" "}
          {dashboard?.streak === 1 ? "week" : "weeks"} of zero waste!
        </p>
      </div>



      <div className="stat-grid" style={{ marginTop: 16 }}>

        <div className="stat-box">

          <div className="stat-value">
            {dashboard?.mealsCooked || ''}
          </div>

          <div className="stat-label">
            Meals cooked from pantry
          </div>

        </div>


        <div className="stat-box">

          <div className="stat-value">
            ${dashboard?.totalSaved.toFixed(2) || 0.0}
          </div>

          <div className="stat-label">
            Money saved by reducing waste
          </div>

        </div>

      </div>



      <h2 className="category-header" style={{ marginTop: 24 }}>
        Savings Over Time
      </h2>


      {/* FIX: fixed width={500} overflowed the .screen container,
          which is capped at 480px everywhere else in this app.
          ResponsiveContainer scales the chart to its parent instead. */}
      <div className="ticket" style={{ height: 240 }}>

        <ResponsiveContainer width="100%" height="100%">

          <LineChart data={dashboard?.history}>

            <CartesianGrid stroke="#2a2a2a" />

            <XAxis
              dataKey="date"
              stroke="#9a9a95"
              fontSize={12}
            />

            <YAxis stroke="#9a9a95" fontSize={12} />

            <Tooltip
              contentStyle={{
                background: "#1c1c1c",
                border: "1px solid #2a2a2a",
              }}
              labelStyle={{ color: "#f4f4f2" }}
            />

            <Line
              type="monotone"
              dataKey="saved"
              stroke="#00e676"
              strokeWidth={2}
              dot={false}
            />

          </LineChart>

        </ResponsiveContainer>

      </div>

      
        <div
  style={{
    display: "flex",
    alignItems: "flex-end",
    gap: 14,
    height: 260,
    marginTop: 25,
    padding: "20px 10px 0",
  }}
>
  {(weeklySavings ?? []).map(day => {
  const maxSaved = Math.max(
    ...(weeklySavings ?? []).map(item => item.saved),
    1
  );

  const height = (day.saved / maxSaved) * 180;

  return (
    <div
      key={day.date}
      style={{
        flex: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-end",
        minWidth: 35,
        color: "#8a8a86",
      }}
    >
      {/* Amount */}
      <span
        style={{
          fontSize: 12,
          fontWeight: 600,
          marginBottom: 8,
          fontFamily: "var(--font-mono)",
          color: "#9a9a95",
        }}
      >
        ${day.saved.toFixed(0)}
      </span>

      {/* Bar */}
      <div
        style={{
          width: "100%",
          maxWidth: 55,
          height: `${Math.max(height, 8)}px`,
          background: "#087a45",
          borderRadius: "8px 8px 3px 3px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.4)",
          transition: "height 0.3s ease",
        }}
      />

      {/* Day / X-axis labels */}
      <span
        style={{
          fontSize: 11,
          fontWeight: 500,
          marginTop: 10,
          color: "#777772",
          opacity: 1,
        }}
      >
        {new Date(day.date).toLocaleDateString("en-US", {
          weekday: "short",
        })}
      </span>
    </div>
  );
})}
</div>



    </div>

  );

}